import dayjs from 'dayjs';
import { uniqBy } from 'lodash';

import { OcrAccountOrderOption } from '@/modules/UseMyMoney/UseMyMoney.types';

export const getAvailableAccounts = (accounts?: OcrAccountOrderOption[]) => {
  if (!accounts?.length) {
    return;
  }

  const currentDate = dayjs().startOf('date').valueOf();

  const filteredAccountOrders = accounts
    ?.flat()
    ?.filter((accountOrder) => {
      const submitClaimsDateEnd = accountOrder?.submitClaimsDateEnd
        ? dayjs(accountOrder?.submitClaimsDateEnd).valueOf()
        : 0;
      const isClaimsDateExpired = submitClaimsDateEnd && submitClaimsDateEnd < currentDate;
      return accountOrder?.planName && !isClaimsDateExpired;
    })
    ?.sort((prev, next) => ((prev?.order || 0) > (next?.order || 0) ? 1 : -1));

  return uniqBy(filteredAccountOrders, 'accountId');
};
